import Loader from "react-loader-spinner";
import { faList, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { Button, Form, FormGroup, Modal, Row } from "react-bootstrap";
import BihamtaTable from "../../Components/BihamtaTable";
import { GetChequeListForChequeFunction, chequeStatuses, getAllBankAccount, getChequeListToPay } from "../store/api/DocumentsAPI";
import { CheckSquare, Search } from "react-bootstrap-icons";

const ModalSelectCheque = (props) => {
    const { popData, setPopData } = props;
    const { Show, onSelect, Value, ChequeStatus, AccountID, AccountCat, selectMany } = popData;
    const selectedRows = useRef([]);
    const searchData = useRef({});
    const inputChqNumber = useRef();
    const [bankList, setBankList] = useState({ Data: [] });
    const [dataList, setDataList] = useState({ Data: [] });

    function close() {
        setPopData({
            Show: false
        })
        searchData.current = {};
        selectedRows.current = [];
        setDataList({Data:[]});
    }
    function rowClick(row) {
        if (selectMany) {
            return;
        }
        if (row.e) {
            delete row.e;
        }
        if (onSelect) {
            searchData.current = {};
            onSelect({ ...row });
            setPopData({
                Show: false
            })
        }
    }
    function setData(e) {
        searchData.current[e.target.name] = e.target.value;
    }
    function search(e) {
        if (e.key && e.key !== "Enter") {
            return;
        }
        if (Number(AccountCat) > 0) {
            searchData.current.AccountCat = AccountCat;
        }
        if (Number(AccountID) > 0) {
            searchData.current.AccountID = AccountID;
        }
        searchData.current.Status = ChequeStatus;
        if (chequeStatuses.out_1_PayCheque === ChequeStatus) {
            getChequeListToPay(searchData.current, setDataList);
        }
        else {
            GetChequeListForChequeFunction(searchData.current, setDataList);
        }
    }
    function submitSelect() {
        if (onSelect) {
            onSelect([...selectedRows.current]);
            selectedRows.current = [];
            searchData.current = {};
            setDataList({Data:[]});
            setPopData({
                Show: false
            })
        }
    }
    function selectRow(row) {
        if (!row.e) {
            return;
        }
        const checked = row.e.target.checked;
        const exists = selectedRows.current.some(r => Number(r.ChequeID) === Number(row.ChequeID));
        if (checked) {
            if (exists) {
                return;
            }
            else {
                delete row.e;
                selectedRows.current.push({...row});
            }
        }
        else if (exists) {
            selectedRows.current = selectedRows.current.filter(r => Number(r.ChequeID) !== Number(row.ChequeID));
        }

    }
    function showOtherCols() {
        return ChequeStatus !== chequeStatuses.out_1_PayCheque;
    }
    const tableCols = [
        { colTitle: "", colName: "", colType: "boolean", editable: true, onChange: selectRow, showCondition: () => selectMany },
        { colTitle: "شماره چک", colName: "ChequeNumber", showInMobile: true },
        { colTitle: "نام بانک", colName: "BankName", showInMobile: true },
        { colTitle: "شماره حساب", colName: "BankAccountNo", showInMobile: true },
        { colTitle: "تاریخ سررسید", colName: "PDueDate", showCondition: showOtherCols },
        { colTitle: "مبلغ چک", colName: "ChequeAmount", colType: "currency", showCondition: showOtherCols }
    ]
    useEffect(() => {
        if (Show) {
            if (Value) {
                inputChqNumber.current.value = Value;
                searchData.current.ChequeNumber = Value;
                inputChqNumber.current.focus();
            }
            if (ChequeStatus === chequeStatuses.out_1_PayCheque) {
                getAllBankAccount("", setBankList);
            }
        }
    }, [Show])
    return (
        <Modal show={Show} size={selectMany?"lg":""} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faList} size="lg" />&nbsp;
                    انتخاب چک
                </span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle" style={{ paddingTop: 0 }}>
                <Row>
                    {ChequeStatus === chequeStatuses.out_1_PayCheque &&
                        <FormGroup className="col-md-6">
                            {
                                bankList === "PENDING" &&
                                <div className="form-control">
                                    <Loader type="BallTriangle" color="#bb1370" height={20} width={20} style={{ display: "inline-block" }} />&nbsp;
                                    در حال بارگذاری لیست
                                </div>
                            }
                            {
                                bankList?.Data && Array.isArray(bankList.Data) &&
                                <select className="form-control" name="BankID" onChange={setData}>
                                    <option value="">حساب را انتخاب کنید</option>
                                    {bankList.Data.map((item, i) => <option value={item.ID} key={i}>{item.BankMixedName}</option>)}
                                </select>
                            }

                        </FormGroup>
                    }
                    <FormGroup className="col-md-6">
                        <Form.Control ref={inputChqNumber} name="ChequeNumber" onChange={setData} placeholder="شماره چک" onKeyDown={search} />
                    </FormGroup>
                </Row>
                <Button className="group-Btn mt-2" onClick={search}><Search size={18} />&nbsp; جستجوی چک</Button>
                <div style={{ maxHeight: "250px", overflow: "auto" }} className="scThin mt-2">
                    <BihamtaTable columns={tableCols} dataList={dataList} rowClick={rowClick} className="mt-0 mb-0" />
                </div>
                {selectMany &&
                    <Button className="group-Btn" variant="info" onClick={submitSelect}><CheckSquare size={15} />&nbsp;انتــخاب&nbsp;</Button>}
            </Modal.Body>
        </Modal>
    )
}
export default ModalSelectCheque;